<template>
    <div class="qr-wrap">
        <div class="text" :style="{left: lf + 'px'}"  @click.stop="showQrcode">
            <span class="txt">APP & MINI PROGRAM</span>
            <span :class="{'lf_arrow': !isZk, 'rt_arrow': isZk}"></span>

            <div class="code">
                <ul>
                    <li class="bcolor">
                        <img class="codeImg" src="../../assets/mini_programm.png" alt="">
                        <span class="name">MINI PROGRAM</span>
                    </li>

                    <li>
                        <img class="codeImg" src="../../assets/wx_qrcode.png" alt="" style="width:149px;height:149px;margin-top:2px">
                        <span class="name">DOWNLOAD APP</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name:'qrCode',
    props:{

    },
    data(){
        return{
          isZk: false,
          lf: 0,
          codeShow: true
        }
    },
    methods:{
        showQrcode(){
           this.isZk = !this.isZk
           if(this.isZk) {
               this.lf = -432
           } else {
               this.lf = 0
           }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/color.scss';
    @import '../../style/mixin.scss';
    .qr-wrap {
        position: fixed;
        right: 0;
        bottom: 65px;
        width: 28px;
        height: 210px;
        z-index: 99999;
    }
    .text{
        width: 28px;
        height: 210px;
        background: $c_6DB;
        font-size: 13px;
        color: #fff;
        border-radius: 20px 0 0 20px;
        position: relative;
        cursor: pointer;
        left: 0;
        transition: left .3s ease-in;
        //-432px
        .txt {
            width: 28px;
            color: #fff;
            padding: 3px 4px;
            display: block;
            position: absolute;
            top: 10px;
            writing-mode: bt-lr;
            -webkit-writing-mode: vertical-lr;
            writing-mode: vertical-lr;
            transform: rotate(-180deg);
        }
        .lf_arrow{
            cursor: pointer;
            position: absolute;
            left: 6px;
            bottom: 10px;
            width: 0;
            height: 0;
            border-width: 6px;
            border-style: solid;
            border-color: transparent #fff transparent transparent;
        }
        .rt_arrow {
            position: absolute;
            cursor: pointer;
            left: 10px;
            bottom: 10px;
            width: 0;
            height: 0;
            border-width: 6px;
            border-style: solid;
            border-color: transparent transparent transparent #fff;
        }
    }
    .code{
        width: 432px;
        border: 1px solid $c_6DB;
        position: relative;
        left: 28px;
        .codeImg {
            width: auto;
            height: 154px;
            display: block;
            margin: auto;
        }
        .name {
            clear: both;
            font-size: 14px;
            color: #333;
            margin-top: 12px;
            display: block;
        }
        ul {
            width: 430px;
            height: 210px;
            padding-top: 10px;
            box-sizing: border-box;
            background-color: #fff;
            .bcolor {
                border-right: 1px solid $c_6DB;
            }
            li {
                width: 215px;
                float: left;
                color: #000;
                text-align: center;
                span{
                    font-family: "EperFontLight";
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/public/qrCode.vue